<template>
  <LinkTemplate
    @bundle-kmz="downloadBundleKmz"
    :loading="isLoading"
    :fazenda="fazenda"
  />
</template>

<script>
import LinkTemplate from "@/components/templates/Link.vue";
import { mapActions } from "vuex";

export default {
  components: { LinkTemplate },
  data: () => ({
    isLoading: false,
    fazenda: null,
  }),
  methods: {
    ...mapActions("properties", ["getLink", "bundleKmz"]),
    async downloadBundleKmz() {
      const token = this.$route.params.token;

      if (!token) {
        this.$eventHub.$emit("snackBar", {
          icon: "mdi-alert-circle",
          message: "Não foi possível efetuar o download. Tente novamente",
          type: "error",
        });

        return;
      }

      try {
        const blob = await this.bundleKmz(token);

        if (!blob) throw new Error();

        const url = window.URL.createObjectURL(blob);

        const d = new Date();

        const today = [
          d.getFullYear(),
          String(d.getMonth() + 1).padStart(2, "0"),
          String(d.getDate()).padStart(2, "0"),
        ].join("-");

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${this.fazenda.title} ${today}.kmz`);

        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (e) {
        this.$eventHub.$emit("snackBar", {
          icon: "mdi-alert-circle",
          message: "Não foi possível efetuar o download. Tente novamente",
          type: "error",
        });
      }
    },
  },
  async mounted() {
    this.isLoading = true;
    if (this.$route.params && this.$route.params.token) {
      const r = await this.getLink(this.$route.params.token);

      if (r) this.fazenda = r;
    }

    this.isLoading = false;
  },
};
</script>
